Apdex is a measure of user satisfaction with the performance of your application.
A single number designed to be useful to all the team. A score above 0.85 is
considered good, above 0.94 considered excellent. For more info visit our
<ab-external-link href="https://airbrake.io/blog/airbrake-feature/tracking-user-satisfaction-with-apdex">
  blog post about tracking user satisfaction with Apdex.
</ab-external-link>
